import { CustomSelector } from "../ui/components/CustomSelector";
import { Tbx } from "../ui/component";
import api from "../api";
import {
    disableAiAccess,
    isAiAccessAllowed,
    isSubscriptionGateEnabled,
} from "../utils/aiAccess";

export class TranslateChoice extends CustomSelector {
    init() {
        super.init();

        this.includeComponents({
            resultTabs: "document@#result-tabs",
            subscriptionModal: "document@#SubscriptionModal",
        });

        this.dropdownToggle = this.element?.querySelector?.(
            ".transcribe-toolbar__btn-lang"
        );
        this.dropdownRoot = this.element?.querySelector?.(".dropdown");

        if (this.dropdownToggle) {
            this.dropdownToggle.addEventListener(
                "click",
                (e) => this.handleToolbarClick(e),
                true
            );
        }

        if (this.dropdownRoot) {
            this.dropdownRoot.addEventListener("show.bs.dropdown", (e) => {
                if (!isAiAccessAllowed() && isSubscriptionGateEnabled()) {
                    e.preventDefault();
                }
            });
        }

        this.tlBtn.on("click", () => {
            this.aiTranslate(this.languageCode);
        });
    }

    handleToolbarClick(e) {
        if (!isAiAccessAllowed() && isSubscriptionGateEnabled()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation?.();
            if (this.subscriptionModal?.element?.dataset) {
                this.subscriptionModal.element.dataset.titleMode = "ai";
            }
            this.subscriptionModal?.show();
        }
    }

    async aiTranslate(languageCode) {
        if (!isAiAccessAllowed() && isSubscriptionGateEnabled()) {
            if (this.subscriptionModal?.element?.dataset) {
                this.subscriptionModal.element.dataset.titleMode = "ai";
            }
            this.subscriptionModal?.show();
            return;
        }
        const url = this.tlBtn.url;

        try {
            const data = await api.post(url, {
                languageCode: languageCode,
                ...this.getTransformOptions(),
            });
            if (isSubscriptionGateEnabled()) disableAiAccess();

            const tabId = data.transcription_variant_id;
            const tabName = data.tab_name;
            const editBtn = document.querySelector(".edit-btn");
            const storeUrl = editBtn?.getAttribute("data-bs-store-url");
            const deleteUrl = storeUrl ? `${storeUrl}/${tabId}` : null;

          
            this.resultTabs.ensureVisible?.();
            this.resultTabs.addTabToDownloadChoices?.(tabId, tabName);

            const isAiTab = data.is_ai_tab;
            const isAiTranslate = data.type === "ai_translate";
            const isPending = data.status === "pending";

            const li = this.resultTabs.createTabElement(
                tabId,
                tabName,
                deleteUrl,
                isAiTab,
                isAiTranslate
            );
            const mobileItem = this.resultTabs.createMobileDropdownItem(
                tabId,
                tabName,
                deleteUrl,
                isAiTab,
                isAiTranslate
            );
            const contentDiv = this.resultTabs.createContentElement(
                tabId,
                data.content || "",
                isPending
            );

            this.resultTabs.list?.insertAfterActive?.(li);

            this.resultTabs.mobileSelect?.insertAfterActive?.(mobileItem);
        
            this.resultTabs.contentWrapper.appendChild(contentDiv);
        

            this.resultTabs.changeActiveTab(li);
            if (isPending) {
                this.resultTabs.parent?.statusAiPromt?.();
            }
        } catch (e) {
            console.error(e);
        }
    }

    getTransformOptions() {
        if (!Tbx?.getComponentByElement) return {};

        const checkboxElement = document.querySelector(
            '[data-tbx-component="CheckboxShow"]'
        );
        if (!checkboxElement) return {};

        const checkboxComponent = Tbx.getComponentByElement(checkboxElement);
        const states = checkboxComponent?.states;
        if (!states) return {};

        return {
            speakers: !!states.speakers,
            timestamps: !!states.timestamps,
            maxLineCount: states.subtitles ? states.maxLines : null,
            maxLineWidth: states.subtitles ? states.maxSymbols : null,
        };
    }

    handleOptionSelect(e, optionComponent) {
        e.stopPropagation();

        let languageCode = optionComponent.getAttribute("data-language-code");
        this.languageCode = languageCode;

        const text = optionComponent.textContent.trim();

        if (this.selectedText) {
            this.setSelectedLabel(text);
            this.tlBtn.removeClass("translate-btn-disabled");
        } else {
            this.tlBtn.addClass("translate-btn-disabled");
        }

        this.closeOptions();
    }

}
